import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=51ffa6b0&scoped=true"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"
import style0 from "./FormData.vue?vue&type=style&index=0&id=51ffa6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffa6b0",
  null
  
)

export default component.exports